import React, { useEffect, useState } from 'react';
import { TextField, Typography, Grid } from '@material-ui/core';
import { Link } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles';
import { toast } from 'react-toastify';
import AuthorizationClient from '../single-page/api/AuthorizationClient'
import { TextMaskPhone } from '../components/TextMaskCustom';
// import FileField from '../components/FileField.js'
import LoadingButton from '../components/LoadingButton.js'
import { trackEvent } from '../single-page/utils';

const useStyles = makeStyles((theme) => ({
  newAccount: {
    fontFamily: 'Poppins, sans-serif',
    fontWeight: 500,
    alignSelf: 'start'
  },
  newAccountFooter: {
    alignSelf: 'start',
    fontSize: '14px'
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(3),
    borderRadius: '31px',
    border: '1px solid #6600CB',
    padding: '32px 32px 20px 32px',
    backgroundColor: '#1A3F1B',
  },
  submit: {
    margin: theme.spacing(3, 0, 1),
  },
  submitSignUp: {
    margin: theme.spacing(0),
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  wrapper: {
    margin: theme.spacing(1),
    position: 'relative',
  },
  buttonProgress: {
    color: 'white',
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  link: {
    color: '#D2B5FF',
    textDecoration: 'none'
  },
  link2: {
    color: '#fff',
    textDecoration: 'none'
  }
}));

export default function SignUp() {
  const classes = useStyles();
  const [user, setUser] = useState({
    phone: '',
    email: '',
    password: '',
    password_confirmation: ''
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    trackEvent('Lead', {}, { dedupe: false });
  }, []);

  function sign_up(e) {
    e.preventDefault();
    if (loading) return;

    setLoading(true);
    document.activeElement.blur();
    toast.dismiss();

    AuthorizationClient.signUp(user)
      .then(function(){
        trackEvent(
          'CompleteRegistration',
          {
            ...(user.email && { email: user.email }),
            phone: user.phone.replace(/\D/g, ''),
            first_name: user.social_name?.split(' ')[0],
            last_name: user.social_name?.split(' ').slice(1).join(' ')
          },
          { persistOnRedirect: true, dedupe: false }
        );
        window.location.href = '/site';
      })
      .catch(function(response){
        if (response.status == 422){
          setErrors(response.data.errors);
        } else {
          setErrors({});
        }
      })
      .then(function() {
        setLoading(false);
      });
  }

  return (
    <div className={classes.paper}>
      <Typography className={classes.newAccount} component="h1" variant="h5">
        Crie sua conta
      </Typography>
      <Typography className={classes.newAccountFooter}>
        Crie sua conta para participar
      </Typography>
      <form className={classes.form} onSubmit={sign_up} noValidate>
        <TextField
          required={true}
          key={'phone'}
          id={'phone'}
          name={'phone'}
          label={'Telefone'}
          fullWidth={true}
          autoComplete={'phone'}
          autoFocus={true}
          error={(errors['phone'] || errors['unconfirmed_phone']) && true}
          type={'phone'}
          helperText={errors['phone'] || errors['unconfirmed_phone'] ? (errors['phone'] || errors['unconfirmed_phone']).join(', ') : ''}
          onBlur={(e) => setUser({...user, ['phone']: e.target.value})}
          onChange={(e) => setUser({...user, ['phone']: e.target.value})}
          InputProps={{
            inputComponent: TextMaskPhone,
          }}
        />
        {[
          { name: 'email', label: 'Email', type: 'email', required: true },
          { name: 'social_name', label: 'Nome Social (opcional)', type: 'text', required: false },
          { name: 'password', label: 'Senha', type: 'password', required: true },
          { name: 'password_confirmation', label: 'Confirmação da senha', type: 'password', required: true }
        ].map((field) =>
          <TextField
            required={field.required}
            key={field.name}
            id={field.name}
            name={field.name}
            label={field.label}
            fullWidth={true}
            autoComplete={field.name}
            autoFocus={field.autoFocus}
            value={user[field.name]}
            error={errors[field.name] && true}
            type={field.type}
            helperText={errors[field.name] ? errors[field.name].join(', ') : ''}
            onBlur={(e) => setUser({...user, [field.name]: e.target.value})}
            onChange={(e) => setUser({...user, [field.name]: e.target.value})}
          />
          )}
        <Typography style={{ fontSize: '14px', paddingTop: '10px' }}>
          Ao clicar, você concorda com <a href='/site/termos' target='_blank' className={classes.link}>Termos e condições</a> e <a href='/site/termos' target='_blank' className={classes.link}>Política de privacidade</a>
        </Typography>
        <LoadingButton
          type="submit"
          fullWidth
          loading={loading}
          variant="contained"
          color="primary"
          className={classes.submit}
        >
          CONTINUAR
        </LoadingButton>
        <LoadingButton
          fullWidth
          loading={loading}
          variant="contained"
          color="primary"
          className={classes.submitSignUp}
        >
          <Link className={classes.link2} to="/public/sign_in">
            ENTRAR
          </Link>
        </LoadingButton>
      </form>
      <Grid container style={{ display: 'flex', flexDirection: 'column' }}>
        <Grid style={{ padding: '20px 20px 10px 20px' }} item>
          <Link className={classes.link} to="/public/request_password_reset" variant="body2">
            Esqueceu sua senha?
          </Link>
        </Grid>
      </Grid>
    </div>
  );
}
